import styled from '@emotion/styled'
import { Checkbox, MenuItem, TextField, Theme } from '@mui/material'
import { COLORS } from 'app-constants'
import StyledSelectTextField from 'components/StyledSelectTextField'
import { getColorForDarkMode, getElementColor } from 'utils/darkMode'

export const CheckboxWithDarkMode = styled(Checkbox)<{ theme: Theme }>`
  margin-right: 8px;
  padding: 0;
`

// isDarkBackdrop: boolean - this is true when the backdrop of the parent component may be dark (sometimes it is not)
export const TextFieldWithDarkMode = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isDarkBackdrop',
})<{ theme: any; isDarkBackdrop: boolean }>`
  pt: 0;
  background: #ffffff;

  & ::placeholder {
    font-weight: 400;
  }
  & .MuiOutlinedInput-input {
    padding: 0;
  }
  & .MuiOutlinedInput-root {
    background: transparent;
    line-height: 24px;
    padding: 8px 12px;
  }

  & .MuiFormLabel-root {
    color: ${(props) => getElementColor(props.isDarkBackdrop, props.theme)};
    font-weight: 600;
    font-size: 16px;
  }
  & input.Mui-disabled {
    -webkit-text-fill-color: #666666;
  }
  & label.Mui-disabled {
    -webkit-text-fill-color: ${(props) => getColorForDarkMode(props.theme)};
  }
  & .MuiFormHelperText-root {
    padding-right: 16px;
    padding-bottom: 8px;
  }
  & .MuiSvgIcon-root {
    margin-right: 8px;
  }
`

export const MenuItemWithDarkMode = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ theme: Theme; isSelected: boolean }>`
  color: ${(props) => (props.theme.palette.mode === 'light' && !props.isSelected ? COLORS.GRAY_0 : COLORS.PURE_WHITE)};
  &:hover {
    color: ${(props) =>
      props.theme.palette.mode === 'light' && !props.isSelected ? COLORS.GRAY_0 : COLORS.PURE_WHITE};
  }
`

// isDarkBackdrop: boolean - this is true when the backdrop of the parent component may be dark (sometimes it is not)
export const StyledSelectTextFieldWithDarkMode = styled(StyledSelectTextField)<{
  theme: Theme
  isDarkBackdrop: boolean
}>`
  & .MuiSelect-select {
    padding: 8px 12px;
  }
  & .MuiFormLabel-root {
    color: ${(props) => getElementColor(props.isDarkBackdrop, props.theme)};
  }
  & .MuiSvgIcon-root {
    color: #222222;
  }
`
